import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from './box';
import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, isSocialNetwork } from '../../../constants/utils/connectionTypes';
import { ServicesEdit } from './../_common/servicesEdit';
import { deleteService } from '../../../actions/user-api';
import { DeleteModal } from './deleteModal';

export const Dashboard = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const services = useSelector(state => state.services);
    const [spiderBoxes, setSpiderBoxes] = useState([]);
    const [selectedService, setSelectedService] = useState(undefined);
    const [widthIsBigger, setWidthIsBigger] = useState(false);
    const isFirefox = typeof InstallTrigger !== 'undefined';


    function addOrRemove(connectionType) {
        let optionIsSocNet = connectionType === ConnectionTypes.socialNetworks;
        let optionIsVehicleIns = connectionType === ConnectionTypes.insurance;

        let tmpSelected = JSON.parse(JSON.stringify(user.services));
        if (tmpSelected.findIndex(o => optionIsSocNet ? isSocialNetwork(o.connectionType) : optionIsVehicleIns ? isInsurance(o.connectionType) : o.connectionType === connectionType) !== -1) {
            tmpSelected = tmpSelected.filter(o => optionIsSocNet ? !isSocialNetwork(o.connectionType) : optionIsVehicleIns ? !isInsurance(o.connectionType) : o.connectionType !== connectionType);
            let servicesToDelete = user.services.filter(sv => optionIsSocNet ? isSocialNetwork(sv.connectionType) : optionIsVehicleIns ? isInsurance(sv.connectionType) :
                sv.connectionType === connectionType);

            servicesToDelete.forEach(serviceToDelete => {
                dispatch(deleteService(user.user, serviceToDelete));
            });
        }
    }

    function isInsurance(str) {
        if (str === ConnectionTypes.voitureAssurance || str === ConnectionTypes.bateau || str === ConnectionTypes.moto || str === ConnectionTypes.scooter) {
            return true;
        }
        return false;
    }

    function service(connectionType, title, icon) { return { connectionType: connectionType, title: title, icon: icon }; };
    function getContracts(conType) {
        if (Object.keys(services.serviceData).indexOf(conType) > -1 && services.serviceData[conType].length > 0) {
            return services.serviceData[conType];
        }
        return [];
    }

    function initBoxes() {
        let tmpSpiderBoxes = [];
        let tmp = [];

        [CommonServices].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon));
            });
        });
        R.sortWith([R.ascend(R.prop('title'))])(tmp.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1)).forEach(s => {
            tmpSpiderBoxes.push({ title: s.title, icon: s.icon, contracts: getContracts(s.connectionType), connectionType: s.connectionType });
        });

        tmp = [];
        [PersonalServices, AuxiliarOptions].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon));
            });
        });
        R.sortWith([R.ascend(R.prop('title'))])(tmp.filter(u => user.services.findIndex(i => isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType :
            isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType) !== -1)).forEach(s => {
                tmpSpiderBoxes.push({ title: s.title, icon: s.icon, contracts: getContracts(s.connectionType), connectionType: s.connectionType });
            });

        tmp = [];
        [OtherService].forEach(services => {
            (Object.entries(services).map(entry => entry[1])).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon));
            });
        });
        R.sortWith([R.ascend(R.prop('title'))])(tmp.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1)).forEach(s => {
            tmpSpiderBoxes.push({ title: s.title, icon: s.icon, contracts: getContracts(s.connectionType), connectionType: s.connectionType });
        });
        setSpiderBoxes(tmpSpiderBoxes);
    }

    useEffect(() => {
        initBoxes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        initBoxes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [services, user.user]);

    useEffect(() => {
        if (!R.isNil(user.profilePicture)) {
            let i = new Image();
            i.onload = function () {
                setWidthIsBigger(i.width > i.height);
            };
            i.src = user.profilePicture;
        }
    }, [user.profilePicture]);

    return (
        <article className="view-calc pt-3 my-auto">
            <h5 className="sr-only visually-hidden">Dashboard</h5>
            <div className="auto-view mb-lg-0 h-100">
                <div className="container-fluid h-inherit flex-column">
                    <section className={"flex-column flex-grow-1" + (isFirefox ? ' pb-lg' : '')}>
                        <div className="row align-items-center h-inherit gx-3 my-auto">
                            <div className="col-xl-5 grid-sm grid-md-2 grid-lg-1 mb-xs mb-xl-0 gy-gd-1">
                                {
                                    spiderBoxes.map((s, index) => {
                                        if (index === 0 || index % 2 === 0) {
                                            return <Box key={index} alignLeft={true} service={s} setSelectedService={setSelectedService} addOrRemove={addOrRemove} />;
                                        }
                                        return '';
                                    })
                                }
                            </div>
                            <div className="d-none d-xl-block col-xl-2 my-auto z-2">
                                <div className={"d-flex mx-auto h-avatar w-avatar rounded-circle font-weight-bold mb-2 shadow" + (R.isNil(user.profilePicture) ? ' bg-white' : '')}>
                                    {!R.isNil(user.profilePicture) ?
                                        <img className={"img-fluid h-100 w-100 rounded-inherit" + (widthIsBigger ? ' img-contain bg-white border' : ' img-cover')} alt="avatar" src={user.profilePicture} />
                                        :
                                        <i className="eva eva-image-2 h2 lh-1 m-auto icon-default"></i>
                                    }
                                </div>
                            </div>
                            <div className="col-xl-5 justify-content-center grid-sm grid-md-2 grid-lg-1 gy-gd-1">
                                {
                                    spiderBoxes.map((s, index) => {
                                        if (index !== 0 && index % 2 !== 0) {
                                            return <Box key={index} alignLeft={false} service={s} setSelectedService={setSelectedService} addOrRemove={addOrRemove} />;
                                        }
                                        return '';
                                    })
                                }
                            </div>
                        </div>
                    </section>

                    <nav className="flex-column flex-md-row py-2 pb-xl-3 justify-items-center position-sticky z-2 b-0 flex-grow-0 mt-auto">
                        <Link to="/anticipa/communes" className="btn btn-if p-1 rounded-sm shadow-lg btn-white-primary text-primary ml-md-auto mr-md-0 mt-1 mt-md-0"><span className="btn-text px-1 px-md-3 text-truncate mw-50"><span className="d-none d-md-unset">Ajouter</span> <span className="d-none d-lg-unset">organismes</span> <span className="d-lg-none">D.</span>  de bases</span><div className="btn btn-item btn-icon ml-auto"><i className="eva eva-star-outline align-middle fs-lead p-2"></i><i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i></div></Link>
                        <Link to="/anticipa/personal" className="btn btn-if p-1 rounded-sm shadow btn-white-primary text-primary ml-md-2 mr-md-auto mt-1 mt-md-0"><span className="btn-text px-1 px-md-3 text-truncate mw-50"><span className="d-none d-lg-unset">Ajouter</span> organismes complémentaires</span><div className="btn btn-item btn-icon ml-auto"><i className="eva eva-archive-outline align-middle fs-lead p-2"></i><i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i></div></Link>
                    </nav>
                </div>
            </div>
            <ServicesEdit selectedService={selectedService} setSelectedService={setSelectedService} />
            <DeleteModal service={selectedService} addOrRemove={addOrRemove} />
        </article>
    );
};